<template>
  <div class="home">
    This is settings index route
    <router-view></router-view>
  </div>

</template>

<script>
// @ is an alias to /src

export default {
    name: 'settings.index',
    components: {

    }
};
</script>
